import Icon from '../components/Icon.vue'

Icon.register({"otter":{"width":640,"height":512,"paths":[{"d":"M608 32H576L562.8 18.8A64-64 0 0 1 517.5 0H497C485.9 0 474.9 2.9 465.3 8.4L312 96H256C150 96 64 182 64 288V289.6C64 322.4 48 351.8 24.4 374.5 6.3 392.1-3.7 418.2 1.3 446.3 8 485.1 44.1 512 83.5 512H192C209.7 512 224 497.7 224 480S209.7 448 192 448H80C71.2 448 64 440.8 64 432S71.2 416 80 416H304C312.8 416 320 408.8 320 400V384C320 366.3 305.7 352 288 352H224L373.5 271.5 448 416H528C536.8 416 544 408.8 544 400V384C544 366.3 529.7 352 512 352H483.8L428.7 241.8 521.1 192H544C597 192 640 149 640 96V64C640 46.3 625.7 32 608 32zM512 48C520.8 48 528 55.2 528 64S520.8 80 512 80 496 72.8 496 64 503.2 48 512 48zM544 144H509L407.2 198.8 393.4 171.3 512 112H589C582.4 130.6 564.8 144 544 144z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/otter.js
// module id = null
// module chunks = 